"use client";

import { useEffect, useRef } from "react";

import { saveCookieJar } from "@/stf.data/request.logger";

interface ApplyCouponProps {
  sCn: string;
  sCo: string;
}
export const ApplyCoupon = (props: ApplyCouponProps) => {
  const { sCn, sCo } = props;

  useEffect(() => {
    if (!(sCn && sCo)) {
      return;
    }

    const applyCoupon = setTimeout(() => {
      saveCookieJar({ s_cn: sCn, s_co: sCo });
    }, 1000);

    const cleanup = () => {
      clearTimeout(applyCoupon);
    };

    return cleanup;
  }, [sCn, sCo]);

  return null;
};
